import React, { useState, useEffect, useContext } from 'react';
import {Stack} from '@shopify/polaris';
import {FormProvider, useFetch} from '@thinkwell/react.common';
import {EditForm, EditModal} from '@thinkwell/react.polaris';
import {CoursesContext} from '../contexts/Courses'
import EditCourseForm from './EditCourseForm'

export default function EditCourse(props) {
  const [courses, fetchCourses, fetchCoursesState, upsertCourse] = useContext(CoursesContext)

  const item = props.item || {}

  const onEditSave = (response) => {
    props.onSave && props.onSave(response)
    upsertCourse(response)
  }

  const onActive = (active) => {
    props.onActive && props.onActive(active)
  }

  const url = `/courses${item.id ? `/${item.id}` : ''}.json`
  const method = item.id ? 'put' : 'post'
  const title = item.id ? "Edit Course" : "Add Course"

  return (
    <FormProvider data={{data: item}} rootName="course">
      { props.useModal ?
        <EditModal
          active={props.active}
          onActive={onActive}
          onSave={onEditSave}
          url={url}
          method={method}
          linkText={props.linkText || item.name}
          title={title}>
          <EditCourseForm item={props.item}/>
        </EditModal> :
        <EditForm
          active={props.active}
          onActive={onActive}
          onSave={onEditSave}
          url={url}
          method={method}
          title={title}>
          <EditCourseForm item={props.item}/>
        </EditForm>
      }
    </FormProvider>
  );
}
